import { Card } from '@unmind/design-system';
import { AppStore } from 'LoggedOut/AppStore/AppStore';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Namespace } from 'i18next';
import { InviteALovedOne as Img } from 'icons';
import { getChannel } from 'utils';

import './InviteALovedOne.scss';

export const InviteALovedOne = () => {
  const { t: translate } =
    useTranslation<Namespace<'invite_a_loved_one'>>('invite_a_loved_one');
  const { supportUrl } = getChannel();

  return (
    <section className="invite-a-loved-one sass-migrated">
      <div>
        <h2 className="title-l">{translate('title')}</h2>
        <p>{translate('feature_description')}</p>
        <AppStore helpText={translate('app_store_help_text')} />
      </div>

      <Card element="aside">
        <p className="title-xs">{translate('information_panel.header')}</p>
        <Img />
        <ul>
          {['one', 'two', 'three'].map(point => (
            <li key={point}>
              {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
              {translate(`information_panel.bullet_points.${point}` as any)}
            </li>
          ))}
        </ul>
        <small>
          <a
            href={`${supportUrl}/article/8b6285`}
            rel="noopener noreferrer"
            target="_blank"
          >
            {translate('information_panel.faq.description')}
          </a>
        </small>
      </Card>
    </section>
  );
};
